import { InputDialogWrapper } from "./style";

const InputDialog = ({
  title,
  content,
  setContent,
  setIsOpen,
  confirm,
}: {
  title: string;
  content: string;
  setContent: any;
  setIsOpen: any;
  confirm: any;
}) => {
  return (
    <InputDialogWrapper>
      <div className="title">{title}</div>
      <div className="input-box">
        <input
          type="text"
          value={content}
          onChange={(e) => {
            const newValue = e.target.value;
            setContent(newValue);
          }}
        />
      </div>
      <div className="button-wrapper">
        <div
          className="cancel-button"
          onClick={() => {
            setContent("");
            setIsOpen(false);
          }}
        >
          취소
        </div>
        <div
          className="create-button"
          onClick={async () => {
            confirm();
            setContent("");
          }}
        >
          생성
        </div>
      </div>
    </InputDialogWrapper>
  );
};

export default InputDialog;
